// @flow
import * as React from 'react'
import { config } from 'react-awesome-styled-grid'
import styled from 'styled-components'
import { DriveToDownloadModule } from '@components/DriveToDownloadModule'
import { GoodSansB2, QueensH3 } from '@components/shared'
import { colors } from '@components/shared/colors'
import ThemeContext from '@components/shared/ThemeContext'

export function Confirmation (): React.Node {
  const theme = React.useContext(ThemeContext)
  return (
   <DriveToDownloadModule>
      <Header $theme={theme}>You just unlocked 1,000+ original spicy audiobooks and more</Header>
      <SubHeader $theme={theme}>Download the app to experience romantic fiction brought to life. Crafted with care by our team of professional writers and top tier narrators, with Dipsea you can go deep with your favorite characters and get lost in their world.</SubHeader>
   </DriveToDownloadModule>
  )
}

const Header = styled.h1`
  ${QueensH3};
  color: ${(props: any): string => props.$theme === 'pink' ? colors.white : colors.sand};
  margin-bottom: 1rem;
  text-align: center;
  ${(props: any): string => config(props).media.md`
    text-align: left;
  `};
`
const SubHeader = styled.p`
  ${GoodSansB2};
  color: ${(props: any): string => props.$theme === 'pink' ? colors.white : colors.sand};
  margin-bottom: 2rem;
  text-align: center;
  ${(props: any): string => config(props).media.md`
    text-align: left;
  `};
`
